import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'
import { CDN_BASE, img } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: 'Noma Studio',
    description: 'Noma is a brand and web studio for founders who care how they are seen. Fewer projects, more attention, and work that closes the gap between who you are and how you look.',
    placeholder: 'Noma Studio',
    url: getOrigin(),
    ogImage: img('uQzt05iescwLlC6DKg4M1qwR6o.jpg')
}

/* Derived from the one storage address in media.ts, so the two can never drift apart. */
export const CDN = `${CDN_BASE}/images`

export const studioMeta = {
    established: 'EST. 2012',
    years: '2012-26©',
    mark: '®',
    email: 'hello@nomastudio.com',
    phone: '+1 (805) 450 1432',
    address: '2800 East Observatory Road Los Angeles, USA 90027',
    hours: 'Monday to Friday: 9:00 AM – 6:00 PM',
    bases: ['los angeles', 'tokyo'],
    services: ['Brand Identity', 'Web Design', 'Modulify Dev', 'Art Direction']
}

export const navLinks = [
    { label: 'projects', href: '/projects', count: '(6)' },
    { label: 'studio', href: '/studio' },
    { label: 'journal', href: '/journal' },
    { label: 'contact', href: '/contact' }
]
